/* eslint-disable */
import {
  createReqConsts,
  createActions,
  createReqReducer,
  createReqWatcher,
} from '../../utils/redux';

export const consts = createReqConsts('circles', 'cancelFamilyMemberInvitation');
export const actions = createActions(consts);
export const watcher = createReqWatcher(consts, actions, {
  endpoint: 'users',
  type: 'delete',
  slug: [
    {
      type: 'payload',
      selector: ['userId'],
    },
    'inverse_family_member_invitations',
    {
      type: 'payload',
      selector: ['invitationId'],
    },
  ],
});
export default createReqReducer(consts);



// WEBPACK FOOTER //
// ./src/redux/circles/cancelFamilyMemberInvitation.js